import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import './collapsible.scss';

type Props = {
  title?: string,
  titleComponent?: React.ReactNode,
  titleOnClose?: React.ReactNode,
  headerClassName: string,
  iconClassName?: string,
  children: React.ReactNode,
  collapsed?: boolean,
  collapsibleOverride?: boolean,
  isTransparent?: boolean,
  arrowPosition: 'left' | 'right'
};

type State = {
  isCollapsed: boolean
};

class Collapsible extends React.PureComponent<Props, State> {
  static defaultProps = {
    collapsibleOverride: false,
    headerClassName: '',
    arrowPosition: 'right'
  };

  state = {
    isCollapsed: this.props.collapsed || false
  };

  onHeaderClick = (): void => {
    const { collapsibleOverride } = this.props;
    const { isCollapsed } = this.state;

    if (!collapsibleOverride) {
      this.setState({
        isCollapsed: !isCollapsed
      });
    }
  };

  render(): React.ReactNode {
    const {
      children,
      title,
      titleComponent,
      titleOnClose,
      headerClassName,
      iconClassName,
      collapsibleOverride,
      arrowPosition,
      isTransparent
    } = this.props;

    const { isCollapsed } = this.state;
    const isOpen = !isCollapsed;

    const classes = classnames({
      'collapsible': true,
      'collapsible--transparent': isTransparent
    });

    const headerClasses = classnames({
      'collapsible__header': true,
      'collapsible__header--open': isOpen,
      'collapsible__header--override': collapsibleOverride,
      'collapsible__header--transparent': isTransparent,
      [`collapsible__header--arrow-${arrowPosition}`]: arrowPosition,
      [headerClassName]: Boolean(headerClassName)
    });

    const titleOnCloseClasses = classnames({
      'collapsible__title-on-close': true,
      'collapsible__title-on-close--show': !isOpen
    });

    const containerClasses = classnames({
      'collapsible__body-container': true,
      'collapsible__body-container--collapsed': !isOpen
    });

    const iconClasses = classnames({
      'collapsible__icon': true,
      'collapsible__icon--open': isOpen,
      [`collapsible__icon--position-${arrowPosition}`]: arrowPosition,
      [String(iconClassName)]: Boolean(iconClassName)
    });

    return (
      <section className={classes}>
        <div
          onClick={this.onHeaderClick}
          className={headerClasses}
        >
          {
            !collapsibleOverride && arrowPosition === 'left' && (
              <div className={iconClasses}>
                <SVGDynamicIcon
                  name="chevron-down-custom-fg"
                  width={13}
                  height={6}
                />
              </div>
            )
          }
          <div className="collapsible__title">
            {
              title && (
                <span>{title}</span>
              )
            }
            {
              titleOnClose && (
                <div className={titleOnCloseClasses}>
                  {titleOnClose}
                </div>
              )
            }
            {
              titleComponent
            }
          </div>
          {
            !collapsibleOverride && arrowPosition === 'right' && (
              <div className={iconClasses}>
                <SVGDynamicIcon
                  name="chevron-down-custom-fg"
                  width={13}
                  height={6}
                />
              </div>
            )
          }
        </div>
        <div className={containerClasses}>
          {children}
        </div>
      </section>
    );
  }
}

export default Collapsible;
